import {getPrefixedDataSet} from "@elements/data-set-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {findAllIn, findIn, on, hasClass, removeClass, addClass, trigger} from "@elements/dom-utils";
import {showNotification} from '@elements/alert-notification';

const defaultSelectors = {
    base: '.js-pool-enquiry',
    button: '.js-pool-enquiry__btn',
    submitForm: '.js-pool-enquiry__submit-form',
    selectionView: '.js-pool-enquiry__selection-view',
    counter: '.js-pool-enquiry__counter'
};

const defaultOptions = {
    selectors: defaultSelectors,
    sessionStorageName: 'pool-enquiry',
    renderFunctions: {
        "inputs": {
            'item':(data) => {
                let markupElementInput = document.createElement('div');
                markupElementInput.innerHTML = `<input class="" name="pool-enquiries[]" id="" value="${data.id}" hidden>`;

                return markupElementInput.childNodes[0];
            }
        },
        "result": {
            'item': (data, onRemove, baseElement) => {
                let markupElementItem = document.createElement('div');
                let markupElementRemoveButton = document.createElement('div');

                markupElementItem.innerHTML = `<div class="bg-secondary text-white mb-3 p-2 rounded d-flex justify-content-between"><div>${data.title}</div></div>`;
                markupElementRemoveButton.innerHTML = '<button class="btn btn-primary">remove</button>';

                const removeClickHandler = evt => {
                    onRemove(data.id, {}, baseElement);
                };

                on('click', removeClickHandler, markupElementRemoveButton.childNodes[0]);
                markupElementItem.childNodes[0].appendChild(markupElementRemoveButton.childNodes[0]);
                return markupElementItem.childNodes[0];
            },
            'fallback': '<div class="">Es wurde noch nichts hinzugefügt.</div>'
        }
    },
    maxItemsNotification: {
        type: 'warning',
        title: 'Maximale Anzahl erreicht',
        content: 'Es können nur 2 Anfragen gemacht werden',
        closable: true,
        styleModifier: 'pool-enquiry-max-items-notification',
        icon: 'warning',
    }
};

let enquiryList = [];
let elementOptions;
export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createPoolEnquiry(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createPoolEnquiry(baseElement, options = defaultOptions, selectors = defaultSelectors) {

    elementOptions = {
        ...defaultOptions,
        ...options,
        ...getPrefixedDataSet('pool-enquiry', baseElement)
    };

    let sessionStorageName = elementOptions.sessionStorageName;
    let selectionView = findIn(elementOptions.selectors.selectionView, baseElement);
    let button = findAllIn(elementOptions.selectors.button, baseElement);
    let submitForm = findIn(elementOptions.selectors.submitForm, baseElement);

    // initializing...
    selectionView.innerHTML = '';
    let data = getSessionData(sessionStorageName);
    renderResult(baseElement, data, elementOptions);
    updateUI(elementOptions, baseElement);

    const buttonClickHandler = (evt, button) => {
        evt.preventDefault();


        if(hasClass('active', button)) {
            removeClass('active', button);
            let id = transformDataSetOptions(getPrefixedDataSet('pool-enquiry', button)).data.id;
            removeFromList(id, elementOptions, baseElement);
        } else {
            let counter = getCounter(elementOptions.sessionStorageName);

            if(!elementOptions.maxItems || counter < elementOptions.maxItems){
                addClass('active', button);
                let data = getSessionData(sessionStorageName);
                let counter = data.length;

                // remove fallback text before adding Items
                if(data.length === 0) {
                    let selectionView = findIn(elementOptions.selectors.selectionView, baseElement);
                    selectionView.innerHTML = '';
                }
                addToList(baseElement, transformDataSetOptions(getPrefixedDataSet('pool-enquiry', button)).data, elementOptions, data.length, counter);

                updateCounter(elementOptions,baseElement);
            }else{
                showNotification(options.maxItemsNotification);
                triggerEvent("showNotification");
            }

        }
    };

    button.forEach((btn) => {
        on('click', (evt) => buttonClickHandler(evt, btn), btn);
    });

    // remove sessionStorage after form-submit
    const submitHandler = evt => {
        try {
            sessionStorage.removeItem(sessionStorageName);
        } catch (err) {
            console.warn(`pool-enquiry: sessionStorage ${sessionStorageName} could not be removed!`);
        }
    };

    on('submit', submitHandler, submitForm);

}


const triggerEvent = function(eventname){
    trigger(eventname + '.pool-enquiry', document);
};

function renderResult(baseElement, data, options) {
    let counter = 0;
    if(data.length > 0) {
        //  data.forEach(item => addToList(baseElement, item, options));
        data.forEach(function (item) {
            counter = counter+1;
            addToList(baseElement, item, options, data.length, counter)
        });
    } else {

        renderItem(baseElement, options);
        triggerEvent("rendered");
    }

}

function addToList(baseElement, data, options, dataLength, counter) {
    const hasId = enquiryList.some(element => element.id === data.id);
    if (!hasId){
        enquiryList.push(data);
    }
    try {
        sessionStorage.removeItem(options.sessionStorageName);
        sessionStorage.setItem(options.sessionStorageName, JSON.stringify(enquiryList));
    } catch (err) {
        console.warn(`pool-enquiry: Item ${options.sessionStorageName}, sessionStorage ${options.sessionStorageName} could not be set!`);
    }
    renderItem(baseElement, options, data);


    // check if the last item is added, then trigger rendered event
    if (counter === dataLength){
        triggerEvent("rendered");
    }
}

function renderItem(baseElement, options, data = null) {
    let selectionViews = findAllIn(options.selectors.selectionView, baseElement);

    for(let renderFunc in options.renderFunctions) {

        selectionViews.forEach(function (el) {
            if(el.dataset.poolEnquiryView === renderFunc) {
                if(Object.keys(enquiryList).length === 0) {
                    if(typeof options.renderFunctions[renderFunc]['fallback'] !== 'undefined') {
                        el.innerHTML = options.renderFunctions[renderFunc]['fallback'];
                    }
                } else {
                    let markupEl = document.createElement('div');

                    markupEl.appendChild(options.renderFunctions[renderFunc]['item'](data, removeFromList, baseElement));
                    el.appendChild(markupEl.childNodes[0]);
                }
            }
        });
    }
}

function removeFromList(id, options, baseElement) {
    enquiryList = enquiryList.filter(el => el.id !== id);

    options = {
        ...elementOptions,
        ...options,
        ...getPrefixedDataSet('pool-enquiry', baseElement)
    };

    try {
        sessionStorage.removeItem(options.sessionStorageName);
        sessionStorage.setItem(options.sessionStorageName, JSON.stringify(enquiryList));

        let selectionViews = findAllIn(options.selectors.selectionView, baseElement);
        selectionViews.forEach(function (selectionView) {
            selectionView.innerHTML = '';
        });
        enquiryList = [];
        let data = getSessionData(options.sessionStorageName);
        renderResult(baseElement, data, options);
    } catch(err) {
        console.log('catch', err)

    }

    updateUI(options,baseElement);
}

function updateCounter(options,baseElement) {
    let enquiryList = getSessionData(options.sessionStorageName);
    let counter = findIn(options.selectors.counter, baseElement);
    counter.innerHTML = Object.keys(enquiryList).length;

    if (options.maxItems && Object.keys(enquiryList).length === parseInt(options.maxItems)) {
        addClass('has-max-items',baseElement);
    }else if(options.maxItems){
        removeClass('has-max-items',baseElement);
    }
}

export function getCounter(sessionStorageName) {
    let enquiryList = getSessionData(sessionStorageName);
    return Object.keys(enquiryList).length;
}


function updateButtons(options,baseElement) {
    let storageData = getSessionData(options.sessionStorageName);
    let buttons = findAllIn(options.selectors.button,baseElement);

    buttons.forEach(function (button) {
        removeClass('active', button);
    });

    storageData.forEach(function (item) {
        let id = item.id;
        buttons.forEach(function (button) {
            let data = transformDataSetOptions(getPrefixedDataSet('pool-enquiry', button)).data;
            if (data.id === id) {
                addClass('active', button);
            }
        });
    });
}

function updateUI(options,baseElement) {
    updateButtons(options,baseElement);
    updateCounter(options,baseElement);
}

function getSessionData(name) {
    let data = [];

    try{
        let sessionData = sessionStorage.getItem(name);
        data = sessionData !== null ? JSON.parse(sessionData) : [];
    } catch(err) {
        console.warn(`pool-enquiry: sessionStorage ${name} getItem failed!`);
    }
    return data;
}

function transformDataSetOptions(options = {}) {
    let transformedOptions = {...options};

    if (transformedOptions.data) {
        try {
            transformedOptions.data = JSON.parse(transformedOptions.data)
        } catch (e) {
            transformedOptions.data = null;
            console.warn('transformDataSetOptions error');
        }
    }

    return transformedOptions;
}
